<template>
  <div class="listmain ">
    <h1 class="firTitle">智能家居授权流程介绍</h1>
	  <span>
<p>
	<strong class="ql-author-7802039 ql-size-9">1、概述</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">采用通用的OAuth2.0开放授权协议,可以让OrionOS在不获取合作方用户名和密码的前提下,访问用户授权的资源,协议规范可以访问OAuth2.0官方网站：</span><a class="ql-link ql-author-7802039 ql-size-9" href="https://oauth.net/2/" target="_blank">https://oauth.net/2/</a>
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">2、鉴权流程</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（1）OrionOS在开发者开放平台或者其他第三方平台注册一个应用,获取到相应的ClientId 和ClientISecret</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（2）OrionOS向开发者OAuth2.0服务发起一个授权请求</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（3）开发者OAuth2.0服务向用户展示一个授权页面,用户可进行登陆授权</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（4）用户授权OrionOS客户端应用后,进行回跳到OrionOS 的回调地址上并带上code相关参数</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（5）OrionOS回调地址上根据code会去合作方Oauth 的服务上换取access_token</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（6）通过access_token,小豹AI音箱等设备控制时通过该access_token进行访问合作方的服务</span>
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">3、运行流程</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">OAuth 2.0的运行流程如下图</span>
</p>
</span>
	  <img src="../../../../static/images/smartHomeImg/oauth_yxlc.png" alt="运行流程图">
	  <span>
<p>
	<span class="ql-author-7802039 ql-size-9">（A）用户打开客户端以后,客户端要求用户给予授权。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（B）用户同意给予客户端授权。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（C）客户端使用上一步获得的授权,向认证服务器申请令牌。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（D）认证服务器对客户端进行认证以后,确认无误,同意发放令牌。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（E）客户端使用令牌,向资源服务器申请获取资源。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">（F）资源服务器确认令牌无误,同意向客户端开放资源。</span>
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">4、授权OrionOS 开放平台oauth 基础配置</strong>
</p>
</span>
	  <img src="../../../../static/images/smartHomeImg/server2.png" alt="基础配置图">
	  <span>
<p>
	<span class="ql-author-7802039 ql-size-9">注意：服务配置中请使用安全套接字层超文本传输协议HTTPS并且已经授信</span>
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">5、请求API</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">(A) 用户打开授权链接进行授权</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">参数说明：</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">redirect_uri: OrionOS的回调地址,该地址会加上OrionOS的参数进行urlEncode,所以合作方务必做好参数返回的兼容性</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">client_id: 在合作方上注册的应用Id</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">response_type: 响应方式为code</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">state:表示客户端的当前状态,可以指定任意值,认证服务器会原封不动地返回这个值。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">注：示例中的链接API(</span><a class="ql-link ql-author-7802039 ql-size-9">https://xxx.com/auth/authorize</a><span class="ql-author-7802039 ql-size-9">) 为开放平台中的账户授权链接字段。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">(B) 通过code换取合作方访问令牌</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">例：</span>
</p>
<p>
	<a class="ql-link ql-author-7802039 ql-size-9">https://XXXXX/token?grant_type=authorization_code&amp;client_id=XXXXX&amp;client_secret=XXXXXX&amp;code=XXXXXXXX&amp;redirect_uri</a><span class="ql-author-7802039 ql-size-9">=XXXXXXX</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">请求方法： POST</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">参数说明：</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">client_id: 在合厂商平台上注册的应用Id</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">grant_type: 授权类型 authorization_code</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">client_secret:在厂商平台上注册应用的secret</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">code: 授权登陆后回调OrionOS的地址返回的code</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">redirect_uri: OrionOS的回调地址</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">注：示例中的链接API(&nbsp;</span><a class="ql-link ql-author-7802039 ql-size-9">https://XXXXX/token</a><span class="ql-author-7802039 ql-size-9">) 为开放平台中的Access Token Url 字段。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">通过code换取access_token 响应结构如下(响应格式 application/json)：</span>
</p>
</span>
	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  字段
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  类型
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  解释说明
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  access_token
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  访问token（响应正确时必传递）
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  refresh_token
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  进行刷新access_token的刷新token （响应正确时必传递）
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  expires_in
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  long
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  过期时间时长（响应正确时必传递）
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  open_id
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  用户的唯一标识（响应正确时必传递）
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  error
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  错误响应码 （响应错误时必传递）
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  error_description
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  错误详情 （响应错误时必传递）
			  </td>
		  </tr>
		  </tbody>
	  </table>
	  <!--<img src="../../../../static/images/smartHomeImg/token.png" alt="图">-->
	  <p>
		  <span class="ql-author-7802039 ql-size-9">正常响应：</span>
	  </p>
	  <highlight-code lang="javascript">

		  HTTP/1.1 200 OK
		  {
		  "access_token":"xxxxx",
		  "refresh_token":"xxxxxx",
		  "expires_in":72000,
		  "open_id":"P1GPtrMrTg9RJRcL9Sm3w"
		  }
	  </highlight-code>
	  <!--<img src="../../../../static/images/smartHomeImg/success_res.png" alt="图">-->
	  <p>
		  <span class="ql-author-7802039 ql-size-9">错误响应：</span>
	  </p>
	  <highlight-code lang="javascript">
		  HTTP/1.1 400 Bad Request
		   {
		  "error":"errorCode",
		    "error_description":"description"
		   }
  </highlight-code>
	  <!--<img src="../../../../static/images/smartHomeImg/err_res.png" alt="图">-->
	  <p>
		  <span class="ql-author-7802039 ql-size-9">注： access_token 有效期请设置成1天以上(2-3天最佳)</span>
	  </p>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">(C) 通过refresh_token刷新access_token</span>
	  </p>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">例：</span>
	  </p>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">https://XXXXX/token?grant_type=refresh_token&client_id=XXXXX&client_secret=XXXXXX&refresh_token=XXXXXX</span>
	  </p>
	  <highlight-code lang="javascript">
	  请求方法： POST
	   
	  参数说明：
	    grant_type：更新access_token的授权方式为refresh_token
	    client_id: 在厂商平台上注册的应用Id
	    client_secret:在厂商平台上注册应用的secret
	    refresh_token: 上一次授权获取的refresh_token
	   
	  注：示例中的链接API( https://XXXXX/token) 为开放平台中的Access Token Url 字段。
	  </highlight-code>
	  <!--<img src="../../../../static/images/smartHomeImg/a.png" alt="图">-->
	  <p>
		  <span class="ql-author-7802039 ql-size-9">更新access_token 响应结构如下(响应格式 application/json):</span>
	  </p>
	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  字段
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  类型
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  解释说明
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  access_token
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  访问token（响应正确时必传递）
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  refresh_token
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  进行刷新access_token的刷新token （响应正确时必传递）
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  expires_in
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  long
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  过期时间时长（响应正确时必传递）
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  open_id
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  string
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  用户唯一标识
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  error
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  错误响应码 （响应错误时必传递）
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  error_description
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;text-align:center;">
				  错误详情 （响应错误时必传递）
			  </td>
		  </tr>
		  </tbody>
	  </table>
	  <!--<img src="../../../../static/images/smartHomeImg/b.png" alt="图">-->
	  <p>
		  <span class="ql-author-7802039 ql-size-9">正常响应：</span>
	  </p>
	  <highlight-code lang="javascript">
		  HTTP/1.1 200 OK
		  {
		  "access_token":"xxxxx",
		  "refresh_token":"xxxxxx",
		  "expires_in":72000,
		  "open_id":"P1GPtrMrTg9RJRcL9Sm3w"
		  }
	  </highlight-code>
	  <!--<img src="../../../../static/images/smartHomeImg/success_res2.png" alt="图">-->
	  <p>
		  <span class="ql-author-7802039 ql-size-9">错误响应：</span>
	  </p>
	  <highlight-code lang="javascript">
		  HTTP/1.1 400 Bad Request
		   {
		  "error":"errorCode",
		    "error_description":"description"
		   }
	  </highlight-code>
	  <!--<img src="../../../../static/images/smartHomeImg/err_res2.png" alt="图">-->
	  <span>
<p>
	<span class="ql-author-7802039 ql-size-9">注意事项：</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">1.获取access_token或者刷新access_token出现错误情况时http response status code 请返回非200,接入方的内部异常请接入方自行包装异常信息</span>
</p>
</span>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle {
      margin-top: 50px;
      font-weight: bold;
      line-height: 30px;
      font-size: 16px;
    }
    .codeTitle {
      font-weight: bold;
      line-height: 26px;
    }
    pre {
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
      width: 100%;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tutor/smartHome/Zn_sqlc.vue